<app-secondary-button
  [text]="'portal.hrisIntegration.setupButton' | transloco"
  [loading]="hrisIntegrationDataService.isCreatingHRISIntegration"
  [disabled]="hrisIntegrationDataService.isLoadingHRISIntegration"
  (buttonClicked)="handleButtonClick()"
>
  <div prepend class="mr-3 flex items-center gap-1">
    @for (
      provider of hrisIntegrationDataService.providers;
      track provider.name;
      let i = $index
    ) {
      @if (i < hrisIntegrationDataService.showProviders) {
        <div
          class="size-7 overflow-hidden rounded-full bg-white p-1 shadow-lg"
          [title]="provider.name"
          [class]="i === 0 ? '' : '-ml-4'"
        >
          <img
            [src]="provider.logoUrl"
            [alt]="provider.name"
            [height]="20"
            [width]="20"
          />
        </div>
      }
      @if (i === hrisIntegrationDataService.showProviders) {
        <div
          class="-ml-4 flex size-7 items-center justify-center rounded-full bg-white text-sm font-semibold text-blue-dark shadow-lg"
        >
          +{{
            hrisIntegrationDataService.providers.length -
              hrisIntegrationDataService.showProviders
          }}
        </div>
      }
    }
  </div>
</app-secondary-button>
